export const selectAllLearningTasks = (state) => state.learningTasks.user;  